// extracted by mini-css-extract-plugin
export default {"buy_top":"Buy_buy_top__w2slN","sort":"Buy_sort__VYXXf","contain":"Buy_contain__h2lr1"};